// importando bibliotecas
import React, { useState, useEffect } from 'react';

import ValidarTokenTrocarSenha from './components/ValidarTokenTrocarSenha.js';

// importando estilos
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import fundo from "../../styles/fundo.svg";
import fundo2 from "../../styles/fundo2.svg";
import GlobalStyle from "../../styles/global.js";
import logo from "../../styles/imagem/Logomarca-06.png";

const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh; /* Faz o Div ocupar 100% da altura da viewport */
  background-image: url(${fundo2});
 overflow: visible;
`;
const FormContainer = styled.form`
  width: 100%;
  max-width: 440px;
  background-color: white;
  display: flex; 
  justify-content: center; 
  align-items: center;
  padding: 0px 10px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 10px 10px 10px 10px;
  gap: 5px;
  flex-direction: column;
  margin: auto;

  @media (max-width: 1360px) {
    max-width: 440px;
    justify-content: space-between; 
  }
  @media (max-width: 1024px) {
    width: 440px;
    justify-content: space-between; 
  }
  @media (max-width: 640px) {
    width: 380px;
    justify-content: space-between; 
  }
  @media (max-width: 480px) {

    width: 340px;
    justify-content: space-between; 
  }
  @media (max-width: 376px) {
    width: 320px;
  }
`;
const Title = styled.h1`
  font-size: 34px;
  color: #545454;
  margin-bottom: 5px;
  font-family: "Arial", sans-serif;

  display: flex;
  justify-content: center; 
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;

  @media (max-width: 480px) {
    font-size: 32px;       /* Reduz o tamanho da fonte */
    margin: 0;            /* Remove a margem */
    text-align: center;   /* Centraliza o texto */
  }

  @media (max-width: 400px) {
    font-size: 30px;       /* Reduz mais o tamanho da fonte */
    margin: 0;            /* Remove a margem */
    text-align: center;   /* Centraliza o texto */
  }
`;
const Input = styled.input`
  font-family: "Open Sans", sans-serif;
  width: 94%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #076633;
  }
`;
const Button = styled.button`
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  background-color: #a5adb0;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-image: url(${fundo});
  }
`;

const Container = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start; 
  text-align: start;
  gap: 10px;
  padding: 0px 10px; 
  height: auto;

`;
const Div3 = styled.div`
  width: 100%;
`;
const Div2 = styled.div`
  padding-top: 30px;
  h2 {
    color: #575757;
    font-size: 20px;
  }
`;
const ContainerButton = styled.div`
  display: flex;
  justify-content: center; 
  align-items: center;
  margin-top: 10px;
`;

const Title3 = styled.nav`
  height: 6rem;
  width: 460px;
  background-image: url(${fundo});
  background-size: cover;
  background-position: center;
  border-radius: 10px 10px 0px 0px;



  @media (max-width: 640px) {
    width: 400px;
  }
  @media (max-width: 480px) {
    width: 360px;
  }
  @media (max-width: 400px) {
    width: 360px;
  }
`;
const Title2 = styled.h2`
  color: #fff;
  font-size: 28px;
  display: flex;
  justify-content: center; /* Centraliza o conteúdo horizontalmente */
  align-items: center; /* Centraliza o conteúdo verticalmente */
  height: 100%;

 
  div {
    display: flex;
    justify-content: center; /* Centraliza horizontalmente */
    align-items: center; /* Centraliza verticalmente */
    width: 100%; /* Opcional: Garante que o div ocupe toda a largura disponível */
    height: 100%;
  }
`;

const ForgotPassword = styled.p`
  font-size: 14px;
  color: #333;
  margin: 10px;
  cursor: pointer;
  text-decoration: underline;

`;

const VerificarToken = () => {

  const urlApi = process.env.REACT_APP_API_URL;

  //--------------------------------------------------------------------------------------------------------------//





  //passa o cpf do input para a função
  const [login, setLogin] = useState('');
  //Controla a visualização do botão
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [emailEnviado, setEmailEnviado] = useState(false);


  // Função de enviar o token para o email
  const handleToken = async () => {
    if (!login) {
      toast.error("Informe o login para receber o e-mail.");
      return;
    }

    setIsButtonDisabled(true); // Bloqueia o botão imediatamente

    try {
      const response = await fetch(`${urlApi}logon/enviar-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login }),
      });

      const textResponse = await response.text();
      const data = JSON.parse(textResponse);
      const id = data.id_usuario;

      if (!response.ok) {
        toast.error(data.error || "Erro ao enviar o token.");
        setEmailEnviado(false);
        setIsButtonDisabled(false);
        await logEvento(id, `Erro ao enviar o token: ${data.error || 'Erro desconhecido'}`);
      } else {
        toast.success(data.mensagem);
        setEmailEnviado(true);
        await logEvento(id, 'Token enviado com sucesso!');
      }

      // ✅ Aguarda 5 minutos antes de liberar o botão novamente
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 1 * 60 * 1000); // 5 minutos

    } catch (error) {
      console.error("Erro", error);
      toast.error("Erro de rede ou erro desconhecido");
      setIsButtonDisabled(false); // Desbloqueia em caso de erro
    }
  };


  const logEvento = async (id, descricao) => {
    try {
      const logData = {
        COD_FUNCIONARIO: id,
        DESC_LOG: descricao,
      };

      const response = await fetch(`${urlApi}logon/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(logData),
      });

      if (!response.ok) {
        throw new Error('Failed to save log');
      }
    } catch (error) {
      console.error('Erro ao salvar log:', error);
    }
  };


  useEffect(() => {
    // Verifica se todos os campos estão preenchidos
    if (login) {
      setIsButtonVisible(true);
    } else {
      setIsButtonVisible(false);
    }
  }, [login]);


  const logar = () => {
    window.location.href = "/login";
  };


  return (
    <Div >
      {!emailEnviado ? (
        <FormContainer>
          <Title3 >
            <Title2>
              <div>
                <img src={logo} alt="Logo" />
              </div>
            </Title2>
          </Title3>
          <Container>

            <Title>Esqueci minha senha</Title>
            <Div2>
              <h2>Informe seu login, para receber instruções no seu email:</h2>
              <div>
                <Input
                  type="text"
                  placeholder="Digite seu login..."
                  value={login}
                  onChange={(e) => setLogin(e.target.value)}
                />
              </div>
            </Div2>
            <Div3>
              <ContainerButton>
                {isButtonVisible && (
                  <Button type="button" onClick={handleToken} disabled={isButtonDisabled}>
                    {isButtonDisabled ? 'Aguarde...' : 'Enviar email'}
                  </Button>
                )}
              </ContainerButton>
            </Div3>


          </Container>


          <ForgotPassword type="button" onClick={logar}>
            Voltar a página de login
          </ForgotPassword>

        </FormContainer>

      ) : (
        <ValidarTokenTrocarSenha login={login} />
      )}

      <GlobalStyle />
      <ToastContainer
        autoClose={1500}
        position={toast.POSITION.BOTTOM_LEFT}
        style={{ width: '400px', fontSize: '22px' }}
      />
    </Div>
  );
};

export default VerificarToken;
